import React from 'react';

export const NAV_TAGLINE =
  "Auralux engineers high-performance color concentrates and functional masterbatches for the world's most demanding polymer applications — where chemistry, precision, and sustainability align.";

export default function NavTaglineStrip({ scrolled = false }) {
  return (
    <div className={`nav-tagline${scrolled ? ' nav-tagline--scrolled' : ''}`} aria-label="Company summary">
      <p className="nav-tagline__text">{NAV_TAGLINE}</p>
    </div>
  );
}
